import { getDocumentsForm } from '../../../selectors/personalAccident/documents';
import { getDocumentIsApiPending } from '../../../selectors/personalAccident/documents';
import { apiTransitionDocumentsForm } from '../../../actions/personalAccident/Documents';
import { getAccessToken } from '../../../selectors/personalAccident/payments';
import axios from 'axios';
import { getCustomerIdValue } from '../../../selectors/personalAccident/personalDetails';

export const documentsSubmitService = (store, next, action) => {
    (async () => {
        if (!getDocumentIsApiPending(store.getState())) {
            store.dispatch(apiTransitionDocumentsForm.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionDocumentsForm.success());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionDocumentsForm.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const documents = getDocumentsForm(state);
    const customerId = getCustomerIdValue(state);

    const payload = {
        id: customerId.value,
        nationalIdCopy: documents.idUpload.value.base64File,
        taxPinCertificate: documents.kraPinUpload.value.base64File,
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-accident/documents';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
